import { useEffect } from "react";

export const useSeo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const domain = "https://hackberryhomebw.com";
    document.title = title;
    const set = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };
    set("name", "description", description);
    set("property", "og:title", title);
    set("property", "og:description", description);
    set("property", "og:url", `${domain}${path}`);
    set("property", "og:type", "restaurant.restaurant");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${domain}${path}`);
  }, [title, description, path]);
};
